var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19V16C8.5 15.1716 9.17157 14.5 10 14.5H18C18.8284 14.5 19.5 15.1716 19.5 16V17.5V19C19.5 19.8284 18.8284 20.5 18 20.5H10C9.17157 20.5 8.5 19.8284 8.5 19Z",
    stroke: "#050022",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16V19C8.5 19.8284 9.17157 20.5 10 20.5H18C18.8284 20.5 19.5 19.8284 19.5 19V17.5V16C19.5 15.1716 18.8284 14.5 18 14.5H10C9.17157 14.5 8.5 15.1716 8.5 16ZM12.5 16.75C12.0858 16.75 11.75 17.0858 11.75 17.5C11.75 17.9142 12.0858 18.25 12.5 18.25H15.5C15.9142 18.25 16.25 17.9142 16.25 17.5C16.25 17.0858 15.9142 16.75 15.5 16.75H12.5Z",
    fill: "#050022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 11.5C16.75 11.9142 17.0858 12.25 17.5 12.25C17.9142 12.25 18.25 11.9142 18.25 11.5H16.75ZM11.25 14.5V11H9.75V14.5H11.25ZM16.75 11V11.5H18.25V11H16.75ZM14 8.25C15.5188 8.25 16.75 9.48122 16.75 11H18.25C18.25 8.65279 16.3472 6.75 14 6.75V8.25ZM11.25 11C11.25 9.48122 12.4812 8.25 14 8.25V6.75C11.6528 6.75 9.75 8.65279 9.75 11H11.25Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c94d3882c1aacf6cdebc8ca32f450ed8.svg";
export { ForwardRef as ReactComponent };